import './SnackbarModal.css'

import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'

import approveIcon from '../imgs/approve.png'
import cancelIcon from '../imgs/cancel.png'

export default function SnackbarModal({ showModal, setShowModal, iconType = 'approve', title, description, buttons = [] }) {
  const [isLoading, setIsLoading] = useState(false)

  // Auto-close after 2.5 seconds if no buttons are provided
  useEffect(() => {
    if (showModal && buttons.length === 0) {
      const timer = setTimeout(() => {
        setShowModal(false)
      }, 2500)

      return () => clearTimeout(timer)
    }
  }, [showModal, buttons.length, setShowModal])

  const getIcon = type => {
    switch (type) {
      case 'cancel':
        return <img src={cancelIcon} alt='Cancel' />
      case 'approve':
        return <img src={approveIcon} alt='Approve' />
    }
  }

  const handleClick = async callback => {
    setIsLoading(true)
    try {
      await callback()
      // console.log("🚀 ~ handleClick ~ res:", res)
    } catch (error) {
      console.error('Error executing snackbar func:', error)
    }
    setIsLoading(false)
    setShowModal(false)
  }

  const handleOverlayClick = e => {
    // Close modal if clicking on the overlay (outside the modal content)
    if (e.target.classList.contains('snackbar-modal-overlay')) {
      setShowModal(false)
    }
  }

  const handleCloseClick = () => {
    setShowModal(false)
  }

  if (!showModal) return null

  return (
    <div className='snackbar-modal-overlay' onClick={handleOverlayClick}>
      <div className='snackbar-modal'>
        {buttons.length === 0 && (
          <button className='snackbar-modal-close-btn' onClick={handleCloseClick} aria-label='Close modal'>
            ×
          </button>
        )}
        <div className='snackbar-modal-icon'>{getIcon(iconType)}</div>
        <div className='snackbar-modal-title'>{title}</div>
        <div className='snackbar-modal-description'>{description}</div>
        <div className='snackbar-modal-divider' />
        {isLoading ? (
          <div style={{ height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : (
          <div className='snackbar-modal-button-row'>
            {buttons.map((btn, idx) => (
              <div key={idx} className={`snackbar-modal-button ${btn.primary ? 'primary' : ''}`} onClick={() => handleClick(btn.onClick)}>
                {btn.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
